import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCentrifugalPump3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 70,
	height: 67,
	viewBox: "0 0 70.0 67.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 22.0 54.0 L 10.0 67.0 L 70.0 67.0 L 58.0 54.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 69.4 25.0 A 30.0 30.0 0.0 0 0 40.0 0.0 L 0.0 0.0 L 0.0 20.0 L 11.55 20.0 A 30.0 30.0 0.0 1 0 69.4 35.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 48.6 25.0 A 10.0 10.0 0.0 1 0 48.6 35.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgCentrifugalPump3;
